import { Check } from "react-bootstrap-icons";

export default function Stepper({ steps }) {

  const completedCount = steps.filter((s) => s.status === "done").length;
  const progress = Math.round((completedCount / steps.length) * 100);



  return (
    <>
       
      <aside className="rb-stepper">
        <div className="stepper-items">
          {steps.map((step, i) => (
            <div key={i} className={`step-item ${step.status}`}>

              {/* CIRCLE */}
              <div className="step-circle">
                {step.status === "done" ? <Check size={16} /> : i + 1}
              </div>

              {/* LABEL — below circle */}
              <span className="step-label">{step.label}</span>

            </div>
          ))}
        </div>

        {/* PROGRESS */}
        <div className="step-progress">
          <p>{progress}%</p>
          <div className="progress-bar">
            <div className="progress-fill" style={{ width: `${progress}%` }} />
          </div>
        </div>
      </aside>
    </>
  );
}